import { render, staticRenderFns } from "./NavTabsLayout.vue?vue&type=template&id=272b2b56&"
import script from "./NavTabsLayout.vue?vue&type=script&lang=js&"
export * from "./NavTabsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports